import { FlowChartIcon } from 'common/builder/components/chart/FlowChart/types/FlowChartIcon'
import { FlowChartNodeHeader } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartNodeHeader'

export class FlowChartNodeHeaderBuilder {
  private header: FlowChartNodeHeader

  constructor(title: string) {
    this.header = {
      title,
    }
  }

  withIcon(icon: FlowChartIcon) {
    this.header.icon = icon
    return this
  }

  withColor(color: string) {
    this.header.color = color
    return this
  }

  build() {
    return this.header
  }
}
